export default __webpack_public_path__ + "static/media/greeting5.87a8510a.svg";